module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-sell-eng.e2ae4351.png";